import type { SoulMapProfileFieldErrors } from './soul-map-profile-fields';

/** Field ids in on-screen order, so the first error found is the topmost. */
const FIELD_INPUT_IDS: Record<keyof SoulMapProfileFieldErrors, string> = {
  birthDate: 'soulmap-birth-date',
  birthTime: 'soulmap-birth-time',
  birthPlace: 'soulmap-birth-place',
};

/**
 * The birth fields sit below the fold in the modal and on small screens, so a
 * failed submit would otherwise look like nothing happened.
 */
export function scrollToFirstSoulMapProfileError(
  errors: SoulMapProfileFieldErrors
) {
  const field = (
    Object.keys(FIELD_INPUT_IDS) as (keyof SoulMapProfileFieldErrors)[]
  ).find((key) => errors[key]);
  if (!field) return;

  document
    .getElementById(FIELD_INPUT_IDS[field])
    ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
